import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { colours } from "../../StyleConstants";
import { StepConnector, stepConnectorClasses } from "@mui/material";
import styled from "@emotion/styled";

type StepperDUCProps = {
    activeStep: number
    stepLabels: string[]
    declined?: boolean
}

const StepperDUC = ({ activeStep, stepLabels, declined=false }: StepperDUCProps) => {

    const CustomisedConnector = styled(StepConnector)(() => ({
        [`& .${stepConnectorClasses.line}`]: {
            height: 1,
            border: "1px",
            backgroundColor: colours.midnightBlue.blue80,
            marginLeft: "-8px",
            marginRight: "-8px",
        },
    }));
    return (
        <Box sx={{ width: "100%" }}>
            <Stepper
                activeStep={activeStep}
                alternativeLabel
                connector={<CustomisedConnector />}
            >
                {stepLabels.map((label, index) => {
                    const stepProps: { completed?: boolean } = {};
                    const labelProps: {
                        optional?: React.ReactNode;
                    } = {};
                    return (
                        <Step aria-current={index + 1 === activeStep ? "step" : "false"} key={label} index={index} {...stepProps} sx={{
                            "& .MuiStepConnector-root .MuiStepConnector-line": {
                                height: "2px"
                            }

                        }}>
                            <StepLabel
                                {...labelProps}
                                sx={{
                                    "& .MuiStepLabel-label": {
                                        fontSize: "12px",
                                        fontWeight: 
                                            index + 1 < activeStep
                                                ? 400
                                                : index + 1 === activeStep
                                                    ? 600
                                                    : 400,
                                        color: 
                                            index + 1 < activeStep
                                                ? colours.orange.orange80
                                                : index + 1 === activeStep && declined
                                                    ? colours.error.error
                                                    : index + 1 === activeStep
                                                        ? colours.orange.orange
                                                        : colours.midnightBlue.blue
                                    },
                                }}
                                StepIconComponent={() => (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "12.5px",
                                            backgroundColor:
                                                index + 1 < activeStep
                                                    ? "transparent"
                                                    : index + 1 === activeStep && declined
                                                        ?  colours.error.error
                                                        : index + 1 === activeStep
                                                            ? colours.orange.orange
                                                            : colours.core.white,
                                            textAlign: "center",
                                            borderColor:
                                                index + 1 < activeStep
                                                    ? colours.orange.orange
                                                    : index + 1 === activeStep && declined
                                                        ? colours.error.error
                                                        : index + 1 === activeStep
                                                            ? colours.orange.orange
                                                            : colours.midnightBlue.blue,
                                            borderStyle: "solid",
                                            borderWidth: "2px",
                                            color:
                                                index + 1 < activeStep
                                                    ? colours.orange.orange
                                                    : index + 1 === activeStep && declined
                                                        ? "white"
                                                        : index + 1 === activeStep
                                                            ? colours.midnightBlue.blue
                                                            : colours.midnightBlue.blue,
                                        }}
                                    >
                                        {index + 1}
                                    </Box>
                                )}
                            >
                                {label}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

        </Box>
    )
}

export default StepperDUC;